import { useQuery } from '@tanstack/react-query'

import { getNotes } from '../../api/notes'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetPartnerNotes(memberId?: string) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_PARTNER_NOTES, memberId],
      queryFn: () => getNotes({ memberId: memberId! }),
      enabled: !!memberId,
   })
}

export { useGetPartnerNotes }
export default useGetPartnerNotes
